import dayjs from "dayjs";

export const formatCurrency = (value) =>
    (typeof value === "number"
        ? value
        : Number.isFinite(Number(value)) ? Number(value) : 0
    )?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) ?? "R$ 0,00";

export const ordenarContasPorCodigo = (contas) => {
    return contas.sort((a, b) => {
        const aParts = String(a.codigo).split('.').map(Number);
        const bParts = String(b.codigo).split('.').map(Number);
        for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
            const aNum = aParts[i] ?? 0;
            const bNum = bParts[i] ?? 0;
            if (aNum !== bNum) return aNum - bNum;
        }
        return 0;
    });
};

export const buildSaldoMap = (saldos) => {
    const map = {};
    if (!saldos) return map;

    let arr = [];
    if (Array.isArray(saldos)) {
        arr = saldos;
    } else if (saldos.data && Array.isArray(saldos.data)) {
        arr = saldos.data;
    } else if (typeof saldos === 'object') {
        arr = [saldos];
    }

    arr.forEach((s) => {
        if (!s || typeof s !== 'object') return;
        const codigo = s?.codigo || s?.contaContabil?.codigo;
        const id = s?.id || s?.contaContabil?.id;

        const saldoData = {
            saldoAnterior: Number(s?.vlTotalSaldoInicial || s?.vl_total_saldo_inicial || 0),
            saldoFinal: Number(s?.vlTotalSaldoFinal || s?.vl_total_saldo_final || 0)
        };

        if (codigo) map[codigo] = saldoData;
        if (id) map[id] = saldoData;
    });
    return map;
};

export const agruparLancamentosPorConta = (lancsRaw, saldoMap) => {
    const map = {};
    const arr = Array.isArray(lancsRaw) ? lancsRaw : (lancsRaw?.data ?? []);

    arr.forEach((l) => {
        const contaInfo = l.contaContabilDebito || {};
        const codigo = l.codigo_conta || contaInfo.codigo || "SemConta";
        const nomeConta = l.nome_conta || contaInfo.nome || "Conta não identificada";
        const contaId = contaInfo.id;

        if (!map[codigo]) {
            // Tentamos buscar o saldo pelo ID da conta, depois pelo código
            const sm = (contaId ? saldoMap[contaId] : null) || saldoMap[codigo] || { saldoAnterior: 0, saldoFinal: 0 };

            map[codigo] = {
                codigo,
                nome: nomeConta,
                saldoAnterior: sm.saldoAnterior,
                debitos: 0,
                creditos: 0,
                lancamentos: [],
            };
        }

        const isDebito = l.tipo === "D";
        const vPartida = l.valor || 0;

        if (isDebito) map[codigo].debitos += vPartida;
        else map[codigo].creditos += vPartida;

        map[codigo].lancamentos.push({
            ...l,
            valorDebito: isDebito ? vPartida : 0,
            valorCredito: isDebito ? 0 : vPartida,
            contrapartida: l.contrapartida || "-"
        });
    });

    const resultado = Object.values(map).map((conta) => {
        const ordenados = conta.lancamentos.sort((a, b) => {
            const dt = dayjs(a.dataReferencia).valueOf() - dayjs(b.dataReferencia).valueOf();
            return dt !== 0 ? dt : (a.id - b.id);
        });

        let saldoCorrente = conta.saldoAnterior;
        const lancamentosComSaldo = ordenados.map((l) => {
            saldoCorrente = saldoCorrente + l.valorDebito - l.valorCredito;
            return { ...l, saldoAcumulado: saldoCorrente };
        });

        return {
            ...conta,
            saldoFinal: saldoCorrente,
            lancamentos: lancamentosComSaldo
        };
    });

    return ordenarContasPorCodigo(resultado);
};
